<template>
  <ContentSection
    :spacing="conditionalSpacing"
    :class="{ '!pt-10 sm:!pt-16': isFirst }"
  >
    <Container
      :indent="isJob || isCourse || isCourtDecision ? 'wide' : 'center'"
    >
      <Bard :data="data.bard" />
    </Container>
  </ContentSection>
</template>

<script setup>
const isJob = inject('isJob', null)
const isCourse = inject('isCourse', null)
const isCourtDecision = inject('isCourtDecision', null)

const props = defineProps({
  data: { type: Object, required: true },
  index: { type: Number, default: null },
  prevComponent: { type: String, default: null },
  nextComponent: { type: String, default: null },
})

const isFirst = computed(() => props.index === 0)

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent
)
</script>
